var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeateroff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.70215,
    width: 5.95745,
    height: 25,
    rx: 2.97872,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.36169,
    width: 5.95745,
    height: 25,
    rx: 2.97872,
    fill: "#0000FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0213,
    width: 5.95745,
    height: 25,
    rx: 2.97872,
    fill: "#0000FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6808,
    width: 5.95745,
    height: 25,
    rx: 2.97872,
    fill: "#0000FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3405,
    width: 5.95745,
    height: 25,
    rx: 2.97872,
    fill: "#0000FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 4.3103,
    width: 1.70213,
    height: 2.58621,
    fill: "#0000FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2979,
    y: 4.3103,
    width: 1.70213,
    height: 2.58621,
    fill: "#0000FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeateroff);
export default __webpack_public_path__ + "static/media/heateroff.96fc13a8a9afb4fd2df764e0fa708da1.svg";
export { ForwardRef as ReactComponent };